export enum ELiveClassHistoryDrawerTab {
  DETAIL = 'DETAIL',
  RECORDING_PARTICIPANTS = 'RECORDING_PARTICIPANTS',
  CLASS_COMMENTS = 'CLASS_COMMENTS',
  LIVE_CLASS_PARTICIPANTS = 'LIVE_CLASS_PARTICIPANTS'
}